import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

/**
 * Prawda wyłącznie w konfiguracji `mock` (`ng serve|build --configuration mock`),
 * bo tylko `environment.mock.ts` ustawia `useMocks: true`.
 *
 * Wszystkie komunikaty o wersji demonstracyjnej zależą od tego tokenu, dzięki
 * czemu nigdy nie pojawią się w buildzie developerskim ani produkcyjnym.
 */
export const DEMO_MODE = new InjectionToken<boolean>('DEMO_MODE', {
  providedIn: 'root',
  factory: () => environment.useMocks,
});
